import { render, staticRenderFns } from "./RetornarRequisicaoModal.vue?vue&type=template&id=2ce287a3&scoped=true"
import script from "./RetornarRequisicaoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./RetornarRequisicaoModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RetornarRequisicaoModal.vue?vue&type=style&index=0&id=2ce287a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce287a3",
  null
  
)

export default component.exports